<template>
  <form ref="form" action="#" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <div class="l-page l-page--step-edit">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <h2 class="c-title__text c-title__text--blue u-fs34">シナリオの新規作成</h2>
          </div>
          <div class="c-progress c-progress--step-message">
            <ul class="c-progress-list">
              <li class="c-progress-list__item">シナリオ名の作成<br />配信条件設定</li>
              <li class="c-progress-list__item">メッセージの作成</li>
              <li class="c-progress-list__item">トリガー設定と<br />追加配信メッセージの作成</li>
              <li class="c-progress-list__item is-current">配信内容の<br />確認</li>
              <li class="c-progress-list__item">設定完了</li>
            </ul>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-message-edit-confirm">
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">シナリオ名</div>
                <div class="p-message-edit-confirm__text">
                  {{ scenario.scenario_name }}
                </div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">プッシュ対象</div>
                <div class="c-tag">
                  <ul class="c-tag-list">
                    <li class="c-tag-list__item c-tag-list__item--green">ブラウザ</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-head l-main-head--sub">
          <div class="c-title">
            <h3 class="c-title__text c-title__text--blue u-fs26">設定している配信条件の確認</h3>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-message-edit-confirm p-message-edit-confirm--details">
            <div class="c-title">
              <div class="c-title__text u-fs24">設定している配信条件の確認</div>
              <div v-show="stepInfo.nextStepNo == 1" class="c-text"><a :href="stepInfo.addConditionUrl + '?scenario_id=' + scenario.scenario_id">編集する</a></div>
            </div>
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">配信条件</div>
                <div class="p-message-edit-confirm__text">{{ getConditionString() }}</div>
              </div>
              <template v-if="hasMessageCondition()">
                <div v-for="(messageCondition, loopIndex1) in firstMessage.message_conditions" :key="loopIndex1" class="p-message-edit-confirm-list__item">
                  <div class="p-message-edit-confirm__title">セグメント条件</div>
                  <ul class="p-message-edit-confirm-segment-list">
                    <li class="p-message-edit-confirm-segment-list__item">選択：{{ getConditionJoinTypeString(messageCondition.condition) }} 条件</li>
                    <li class="p-message-edit-confirm-segment-list__item">
                      {{ getConditionTypeString(messageCondition.condition) }}</li>
                    <li v-for="(conditionDetail, loopIndex2) in getConditionDetails(messageCondition.condition)" :key="loopIndex2" class="p-message-edit-confirm-segment-list__item">
                      {{ stepInfo.conditionOperatorTypes[conditionDetail.condition_operation] }} / {{ getDescription(conditionDetail) }}
                    </li>
                  </ul>
                </div>
              </template>
              <div v-if="hasTopicMessageCondition()" class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">セグメント条件</div>
                <ul class="p-message-edit-confirm-segment-list">
                  <li v-for="(topicConditionDetail, loopIndex3) in getTopicConditionDetails()" :key="loopIndex3" class="p-message-edit-confirm-segment-list__item">
                    {{ getTopicConditionDetailTypeString(topicConditionDetail) }} : {{ getTopicConditionDetailValueString(topicConditionDetail) }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-head l-main-head--sub">
          <div class="c-title">
            <h3 class="c-title__text c-title__text--blue u-fs26">メッセージとトリガー設定の確認</h3>
          </div>
        </div>

        <template v-for="(scenarioMessage, loopIndex4) in scenario.scenario_messages" :key="loopIndex4">
          <div v-if="scenarioMessage.step_no > 1" class="l-main-head l-main-head--connector">
            <div class="c-icon-circle c-icon-circle--blue-2 u-wh80">
              <div class="c-icon-circle__item c-icon-circle__item--white c-icon-circle__item--stroke-white u-wh64">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <use xlink:href="/assets/img/sprite.svg#arrow-line-down" />
                </svg>
              </div>
            </div>
          </div>
          <div v-if="scenarioMessage.step_no > 1" class="l-main-content">
            <div class="p-message-edit-confirm p-message-edit-confirm--details">
              <div class="c-title">
                <div class="c-title__text u-fs24">{{ scenarioMessage.step_no }}通目へのトリガー設定</div>
                <div v-show="(stepInfo.nextStepNo != -1) && (stepInfo.nextStepNo <= scenarioMessage.step_no)" class="c-text"><a :href="stepInfo.addMessageUrl + '?scenario_id=' + scenario.scenario_id + '&step_no=' + scenarioMessage.step_no">編集する</a></div>
              </div>
              <div class="p-step-trigger">
                <div class="p-step-trigger__row">
                  <div class="p-step-trigger__text p-step-trigger__text--action">{{ getDeliverTargetString(scenarioMessage.deliver_target) }}</div>
                </div>
                <div class="p-step-trigger__row">
                  <div class="p-step-trigger__text">に対して</div>
                </div>
                <div class="p-step-trigger__row">
                  <div class="p-step-trigger__text p-step-trigger__text--date">{{ getSpanDay(scenarioMessage.step_no) }}日後</div>
                  <div class="p-step-trigger__text">の</div>
                  <div class="p-step-trigger__text p-step-trigger__text--time">{{ getSpanTimeString(scenarioMessage.step_no) }}</div>
                  <div class="p-step-trigger__text">に{{ scenarioMessage.step_no }}通目のメッセージを配信する</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="scenarioMessage.step_no > 1" class="l-main-head l-main-head--connector">
            <div class="c-icon-circle c-icon-circle--blue-2 u-wh80">
              <div class="c-icon-circle__item c-icon-circle__item--white c-icon-circle__item--stroke-white u-wh64">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <use xlink:href="/assets/img/sprite.svg#arrow-line-down" />
                </svg>
              </div>
            </div>
          </div>
          <div class="l-main-content">
            <div class="p-message-edit-confirm p-message-edit-confirm--preview">
              <div class="c-title c-title--left">
                <div class="c-title__text u-fs24">配信内容</div>
                <div class="c-text u-fs--s">プレビューと実際の配信されるメッセージ表示は異なることがあります</div>
                <div v-show="(stepInfo.nextStepNo != -1) && (stepInfo.nextStepNo <= scenarioMessage.step_no)" class="c-text"><a :href="stepInfo.addMessageUrl + '?scenario_id=' + scenario.scenario_id + '&step_no=' + scenarioMessage.step_no">編集する</a></div>
              </div>
              <div class="p-message-preview-list">
                <div class="p-message-preview-list__block">
                  <div class="p-message-preview__title">
                    <div class="c-text u-text-bold">PCでの配信例</div>
                  </div>
                  <!-- プレビュー: PC -->
                  <message-preview
                    :title="scenarioMessage.message.message_title"
                    :text="scenarioMessage.message.message_text"
                    :url="scenarioMessage.message.click_url"
                    :icon-url="scenarioMessage.message.image_url"
                    :large-image-url="scenarioMessage.message.large_image_url"
                    :has-button-a="scenarioMessage.message.action_button_text_a != null"
                    :has-button-b="scenarioMessage.message.action_button_text_b != null"
                    :action-button-text-a="scenarioMessage.message.action_button_text_a"
                    :action-button-text-b="scenarioMessage.message.action_button_text_b"
                  />
                </div>
                <div class="p-message-preview-list__block">
                  <div class="p-message-preview__title">
                    <div class="c-text u-text-bold">スマホでの配信例</div>
                  </div>
                  <message-preview-sp
                    :title="scenarioMessage.message.message_title"
                    :text="scenarioMessage.message.message_text"
                    :url="scenarioMessage.message.click_url"
                    :icon-url="scenarioMessage.message.image_url"
                    :large-image-url="scenarioMessage.message.large_image_url"
                    :has-button-a="scenarioMessage.message.action_button_text_a != null"
                    :has-button-b="scenarioMessage.message.action_button_text_b != null"
                    :action-button-text-a="scenarioMessage.message.action_button_text_a"
                    :action-button-text-b="scenarioMessage.message.action_button_text_b"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </main>
    </div>
    <div class="p-message-predict p-message-predict--no-number">
      <div class="p-message-predict__content p-message-predict__content--center">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w146 u-fs24"
              type="button"
              name="destroy"
              value="destroy"
              @click="onCancelClick($event)"
            >
              <p class="c-btn__text">作成をやめる</p>
            </button>
          </div>
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w96 u-fs24"
              type="button"
              name="save"
              value="save"
              @click="onSaveClick($event)"
            >
              <p class="c-btn__text">保存する</p>
            </button>
          </div>
        </div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w400 u-h50 u-fs20"
            type="button"
            name="confirm"
            value="next"
            @click="onDistributeClick($event)"
          >
            <p class="c-btn__text">この内容でシナリオ配信を行う</p>
          </button>
        </div>
      </div>
    </div>

    <!-- モーダル: 配信メッセージ設定・配信停止完了メッセージ表示 -->
    <control-modal
      ref="refCompleteModal"
      classes="c-modal--result"
      :body="completeMessage"
      cancel-button-label="シナリオ配信一覧へ"
      :is-active=isCompleteMessage
      :on-close-click="onCloseControlModal"
      :on-cancel-click="onCancelControlModal"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />

  </form>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  props: {
    stepInfo: Object,
    csrfToken: String,
    breadcrumbData: Array,
    scenario: Object,
  },
  data () {
    return {
      completeMessage: '',
      errorMessage: '',
      isCompleteMessage: false,
      isError: false,
      isLoadingSaveBtn: false,
    }
  },
  computed: {
    firstMessage: function () {
      let message = null;
      if (this.scenario && this.scenario.scenario_messages.length > 0) {
        message = this.scenario.scenario_messages[0].message;
      }
      return message;
    },
    messages: function() {
      let messages = [];
      if (this.scenario && this.scenario.scenario_messages.length > 0) {
        this.scenario.scenario_messages.forEach(scenarioMessage => {
          messages.push(scenarioMessage.message);
        });
      }
      return messages;
    }
  },
  mounted: function() {
    import('../../funcs/pages/step-add-condition-confirm').then(module => {
      module.StepAddConditionConfirm();
    });
  },
  methods: {
    onCancelClick: function(event) {
      event.preventDefault();
      location.href = this.stepInfo.cancelUrl;
    },
    onSaveClick: function(event) {
      event.preventDefault();
      this.$refs.form.action = this.stepInfo.saveUrl;
      this.$refs.form.submit();
    },


    onDistributeClick: function(event) {
      event.preventDefault();
      // ローディング表示設定, ボタン無効化設定
      this.isLoadingSaveBtn = true;

      // 設定用パラメタ作成
      const params = {
        scenario_id: this.scenario.scenario_id,
      };

      axios.post('/api/scenario/set',params)
        .then(res => {
          if(this.handleResponse(res)){
            //location.href = this.conditionInfo.listUrl;
            this.completeMessage = 'シナリオ配信の配信設定が完了しました。';
            this.isCompleteMessage = true;
          } else {
            this.isError = true;
            this.errorMessage = (res && res.data && res.data.message)
              ? res.data.message
              : 'シナリオ配信の配信設定に失敗しました';
          }
          // ローディング非表示設定, ボタン有効化設定
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          // サーバーがバリデーションメッセージ(例: 過去日時エラー)を返した場合はそれを表示する
          const serverMessage = error && error.response && error.response.data && error.response.data.message;
          this.errorMessage = serverMessage || 'シナリオ配信の配信設定に失敗しました';
          // ローディング非表示設定, ボタン有効化設定
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
          }, 300);
        });
    },







    /*
        showCalendar: function(name) {
            $("*[name="+name+"]").click();
        },
        onBackClick: function() {
            location.href = this.stepInfo.conditionUrl + '?message_id=' + this.message.message_id;
        },
        onSaveClick: function() {
            // ローディング表示設定, ボタン無効化設定
            this.isLoadingSaveBtn = true;

            // 設定用パラメタ作成
            const params = {
                message_id: this.message.message_id,
            };

            axios.post('/api/message/set',params)
                .then(res => {
                    if(this.handleResponse(res)){
                        //location.href = this.stepInfo.listUrl;
                        this.completeMessage = 'プッシュ通知の配信設定が完了しました。';
                        this.isCompleteMessage = true;
                    } else {
                        this.isError = true;
                        this.errorMessage = (res && res.data && res.data.message)
                            ? res.data.message
                            : 'プッシュ通知の配信設定に失敗しました';
                    }
                    // ローディング非表示設定, ボタン有効化設定
                    setTimeout(() => {
                        this.isLoadingSaveBtn = false;
                    }, 300);
                })
                .catch(error => {
                    this.handleHttpError(error);
                    this.isError = true;
                    this.errorMessage = 'プッシュ通知の配信設定に失敗しました';
                    // ローディング非表示設定, ボタン有効化設定
                    setTimeout(() => {
                        this.isLoadingSaveBtn = false;
                    }, 300);
                });
        },
        getDeliverString: function() {
            let deliverType = this.message.message_deliver.deliver_type;
            let deliverString = '';
            if(deliverType == 1){ // 予約
                deliverString = '予約';
            } else if(deliverType == 3){ // 定期
                let regularType = this.message.message_deliver.regular_type;
                let dayOfTheWeek = ['日','月','火','水','木','金','土'];
                for(let day = 0 ; day < 7 ; day++){
                    if(regularType.substring(day,day+1) == '1'){
                        if(deliverString){
                            deliverString += '・';
                        }
                        deliverString += dayOfTheWeek[day];
                    }
                }
                deliverString = '定期配信：' + deliverString;
            } else if(deliverType == 4){ // 即時
                deliverString = '即時';
            }
            return deliverString;
        },
        getSendStartDateTimeString: function() {
            let sendStartDate = this.message.message_deliver.send_start_date;
            return this.getDisplayDate(sendStartDate) + ' ' + this.getDisplayTime(sendStartDate);
        },
        getSendStartDateString: function() {
            let sendStartDate = this.message.message_deliver.send_start_date;
            return this.getDisplayDate(sendStartDate);
        },
        getSendEndDateString: function() {
            let sendEndDate = this.message.message_deliver.send_end_date;
            return this.getDisplayDate(sendEndDate);
        },
        getSendTimeString: function() {
            return this.message.message_deliver.target_start_time;
        },
        */
    getConditionString: function() {
      let conditionString;
      if(this.firstMessage.topic_flag == 1){
        // ALL
        conditionString = '全配信';
      } else {
        conditionString = 'セグメント配信';
      }

      return conditionString;
    },
    hasMessageCondition: function() {
      return (this.firstMessage.message_conditions && (this.firstMessage.message_conditions.length > 0));
    },
    hasTopicMessageCondition: function() {
      return (this.firstMessage.topic_message_condition);
    },
    getCondition: function() {
      let condition = null;
      if(this.firstMessage.message_conditions && (this.firstMessage.message_conditions.length > 0)){
        let messageCondition = this.firstMessage.message_conditions[0];
        if(messageCondition.condition){
          condition = messageCondition.condition;
        }
      }
      return condition;
    },
    getConditionDetails: function(condition) {
      let conditionDetails = [];
      if(condition){
        conditionDetails = condition.condition_details;
      }
      return conditionDetails;
    },
    getSpanDay: function(stepNo) {
      let spanDay = 0;
      if(stepNo > 1){
        let previousDate = this.scenario.scenario_messages[stepNo-2].message.message_deliver.send_start_date;
        let currentDate = this.scenario.scenario_messages[stepNo-1].message.message_deliver.send_start_date;

        let dateFrom = moment(previousDate.substring(0,10));
        let dateTo = moment(currentDate.substring(0,10));
        spanDay = dateTo.diff(dateFrom, 'days');
        if (spanDay < 0) spanDay = 0;
      }
      return spanDay;
    },
    getSpanTimeString: function(stepNo) {
      let spanTimeString;
      let currentDate = this.scenario.scenario_messages[stepNo-1].message.message_deliver.send_start_date;
      spanTimeString = moment(currentDate).format('H時mm分');
      return spanTimeString;
    },
    getDeliverTargetString: function(deliverTarget) {
      return this.stepInfo.deliverTargetTypes[deliverTarget];
    },
    getConditionJoinTypeString: function(condition) {
      let conditionJoinTypeString = '';
      //let condition = this.getCondition();
      if(condition){
        conditionJoinTypeString = condition.condition_join_type;
      }
      return conditionJoinTypeString;
    },
    getConditionTypeString: function(condition) {
      let conditionTypeString = '';
      //let condition = this.getCondition();
      if(condition){
        let conditionDetails = condition.condition_details;
        if(conditionDetails && (conditionDetails.length > 0)){
          let conditionKey = conditionDetails[0].condition_key;
          conditionTypeString = this.stepInfo.conditionKeyTypes[conditionKey] + '：' + this.stepInfo.conditionKeyExplanations[conditionKey];
        }
      }
      return conditionTypeString;
    },
    getDescription: function (conditionDetail) {
      // 変換が必要なければvalueそのまま
      let description = conditionDetail.condition_value;
      if(this.stepInfo.conditionKeyOptions[conditionDetail.condition_key]){
        let options = this.stepInfo.conditionKeyOptions[conditionDetail.condition_key];

        if(options[conditionDetail.condition_value]){
          // 変換が必要なら変換した値
          description = options[conditionDetail.condition_value];
        }
      }
      return description;
    },
    getTopicConditionDetails: function() {
      let topicConditionDetails = [];
      if(this.firstMessage.topic_message_condition){
        let topicMessageCondition = this.firstMessage.topic_message_condition;
        if(topicMessageCondition.topic_condition){
          topicConditionDetails = topicMessageCondition.topic_condition.topic_condition_details;
        }
      }
      return topicConditionDetails;
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    // クリック: 完了モーダルを閉じる処理
    onCloseControlModal() {
      this.isCompleteMessage = false;
    },
    // クリック: 完了モーダルを閉じる処理
    onCancelControlModal() {
      this.isCompleteMessage = false;
      location.href = this.stepInfo.listUrl;
    },





















  }
}
</script>
